// extracted by mini-css-extract-plugin
export default {"arrowBack":"ArrowBack_arrowBack__GO5l+"};